import React from "react";
import { Link } from "react-router-dom";
import { ShieldAlert, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";
import { usePermissions } from "../context/PermissionsContext";

export default function AccessDenied({ moduleLabel, actionLabel }) {
  return (
    <div className="min-h-[60vh] grid place-items-center" data-testid="access-denied-page">
      <div className="text-center max-w-md space-y-4">
        <div className="mx-auto h-16 w-16 rounded-full bg-rose-50 border border-rose-200 grid place-items-center">
          <ShieldAlert className="h-8 w-8 text-rose-600" />
        </div>
        <h1 className="text-2xl font-display font-bold">Acesso Negado</h1>
        <p className="text-sm text-muted-foreground">
          {moduleLabel && actionLabel
            ? <>Você não tem permissão para <strong>{actionLabel}</strong> em <strong>{moduleLabel}</strong>.</>
            : <>Você não tem permissão para acessar esta página.</>}
        </p>
        <p className="text-xs text-muted-foreground">
          Se você acredita que isto é um erro, entre em contato com o PDG ou com o Administrador do Sistema.
        </p>
        <div className="pt-2">
          <Link to="/">
            <Button variant="outline" data-testid="access-denied-back-home">
              <ArrowLeft className="h-4 w-4 mr-2" /> Voltar ao início
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}

/**
 * Route guard for protecting a whole route by permission.
 * Usage:  <PermGuard module="roles" action="view"><RolesPage /></PermGuard>
 */
export function PermGuard({ module, action, children }) {
  const { can, isLoading } = usePermissions();
  if (isLoading) return null;
  if (!can(module, action)) return <AccessDenied moduleLabel={module} actionLabel={action} />;
  return children;
}

/**
 * AP-096 V2 · Route guard by role list (any of).
 * Usage: <RoleGuard roles={["master_super_admin","pdg","secretary"]}><Page /></RoleGuard>
 */
export function RoleGuard({ roles, children }) {
  const { role, isLoading } = usePermissions();
  if (isLoading) return null;
  if (!Array.isArray(roles) || roles.length === 0) return children;
  if (!roles.includes(role)) return <AccessDenied moduleLabel="verificação" actionLabel="acessar" />;
  return children;
}
